
import { Vue, Component } from 'vue-property-decorator';
import {
    Plms,
    Authorize,
    getToken,
    Pay,
} from '@/service';
import {
    token,
    tokenClear,
    tokenParse,
    tokenCheck,
    encodeBase64,
    decodeBase64,
    userAgent,
} from '@/assets/ts/util';

import loading from '@/components/loading.vue';

@Component({
    name: 'CustomPay',
    components: {
        loading,
    },
})
export default class CustomPay extends Vue {

    public $message!: any;
    // 车场信息
    private park: any = {};
    // 输入金额
    private money: string = '';
    // 备注
    private remark: string = '';
    // 金额输入框焦点状态
    private isFocus: boolean = false;
    private keyItems: any[] = [
        [
            { value: '1', action: this.click },
            { value: '2', action: this.click },
            { value: '3', action: this.click },
        ],
        [
            { value: '4', action: this.click },
            { value: '5', action: this.click },
            { value: '6', action: this.click },
        ],
        [
            { value: '7', action: this.click },
            { value: '8', action: this.click },
            { value: '9', action: this.click },
        ],
        [
            { value: '.', action: this.click },
            { value: '0', action: this.click },
            { value: '删除', action: this.remove },
        ],
    ];
    // 提交状态
    private showLoading: boolean = false;

    public init() {
        if (tokenCheck()) {
            if (this.$route.query.park_id) {
                this.getPark(+this.$route.query.park_id);
            } else {
                this.$message('车场id丢失，请联系负责人');
            }

        } else if (this.$route.query.token_sign && this.$route.query.unionid) {
            if (userAgent() === 'Wechat' && !this.$route.query.openid) {
                Authorize(encodeBase64(location.href));
            } else {
                const { unionid, token_sign } = this.$route.query;

                this.getToken(unionid, token_sign).then((data: any) => {
                    token(data.token);
                    this.init();
                }).catch((err: any) => {
                    // do nothing.
                    console.warn(err);
                });
            }
        } else {
            Authorize(encodeBase64(location.href));
        }
    }

    public getToken(unionid: any, tokenSign: any) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await getToken(unionid, tokenSign);
                resolve(data);
            } catch (err) {
                console.warn(err);
                reject(err);
            }
        });
    }

    public async getPark(parkId: number) {
        try {
            const { data } = await Plms.parkDetail({ park_id: parkId });
            this.park = data || {};
        } catch (err) {
            console.warn(err);
        }
    }

    public focus() {
        if (this.isFocus) {
            return;
        }
        this.isFocus = true;
    }

    public blur() {
        if (!this.isFocus) {
            return;
        }
        this.isFocus = false;
    }

    public remove(e: MouseEvent | TouchEvent) {
        // 解决移动端上touchstart事件与click事件先后触发的情况
        if (e.constructor === MouseEvent
            && 'ontouchstart' in document.documentElement === true) {
            return;
        }
        const money = this.money;
        if (money.length) {
            this.money = money.substring(0, money.length - 1);
        }
    }

    public click(e: MouseEvent | TouchEvent, input: string | number) {
        // 解决移动端上touchstart事件与click事件先后触发的情况
        if (e.constructor === MouseEvent
            && 'ontouchstart' in document.documentElement === true) {
            return;
        }

        const money = this.money;
        if (money.length === 0 && input === '.') {
            this.money = '0.';
        } else {
            if (input === '.') {
                if (money.indexOf('.') === -1) {
                    this.money += '.';
                }
            } else if (money.length === 1) {
                if (money.match(/^[^0]/)) {
                    this.money += input;
                }
            } else {
                this.money += input;
            }
        }
        e.preventDefault();
    }

    public clear() {
        this.money = '';
        this.remark = '';
    }

    public async pay(e: TouchEvent | MouseEvent) {
        if (e.constructor === MouseEvent
            && 'ontouchstart' in document.documentElement === true) {
            return;
        }

        const money = this.money;

        // validate money, park_id here.
        if (money === '') {
            this.$message('请输入金额');
            return;
        } else if (isNaN(Number(money))) {
            this.$message('金额格式不正确');
            return;
        }

        if (!this.park.park_id) {
            this.$message('车场id丢失，请联系负责人');
            return;
        }

        if (!this.remark || this.remark.length < 7) {
            this.$message('请输入完整车牌，谢谢合作');
            return;
        }

        this.showLoading = true;
        try {
            const { data } = await Pay.customMoneyWepay({
                park_id: this.park.park_id,
                money: +this.money,
                remark: this.remark,
            });
            eval(data);
        } catch (err) {
            console.warn(err);
            this.$message(err);
        } finally {
            this.showLoading = false;
        }
    }

    public focusRemark(e: TouchEvent | MouseEvent) {
        const input = document.getElementById('remark-input');
        if (input) {
            input.focus();
        }

        if (this.isFocus) {
            this.blur();
        }
    }

    public blurAll() {
        if (this.isFocus) {
            this.blur();
            return;
        }

        const input = document.getElementById('remark-input');
        if (input && input === document.activeElement) {
            input.blur();
        }
    }

    public touchend(e: TouchEvent) {
        e.preventDefault();
    }

    private created() {
        this.init();
    }
}
